import { Vue, Component, Prop } from 'vue-property-decorator';
import { ImageSizes } from './types';

@Component
export default class ComponentPartCatalogListCardImage extends Vue
{
  @Prop({ type: Boolean, default: false })
  imageBgDefault: boolean;

  @Prop({ type: [Boolean, String], default: false })
  imageBgColor: false | string;

  @Prop({ type: String, default: ImageSizes.COVER })
  imageBgSize: ImageSizes;
}



// WEBPACK FOOTER //
// ./src/components/parts/catalog/list/item/image.ts